<template>
    <v-container
        fluid
        class="fill-height"
    >
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="8"
                md="6"
            >
                <v-card class="elevation-12" :loading="loading">

                    <v-card-title>
                        Авторизация
                    </v-card-title>


                    <div class="text-center ma-12" v-if="loading">
                        <v-progress-circular
                            indeterminate
                            size="70"
                            width="2"
                            color="dark">
                        </v-progress-circular>
                    </div>

                    <v-card-text v-else>
                        Выберите способ авторизации
                        <!--                        <v-btn @click.stop="getAuthCode('VK')" color="#4a76a8" dark block class="my-2">-->
                        <!--                            <v-icon left size="25">{{ icon_vk }}</v-icon>-->
                        <!--                            Вконтакте-->
                        <!--                        </v-btn>-->
                        <a :href="vk_url" class="my-2 v-btn v-btn--block v-btn--contained theme--dark v-size--default"
                           style="background: #4a76a8">
                            <v-icon style="color: white" left size="25">{{ icon_vk }}</v-icon>
                            Вконтакте
                        </a>
                        <v-btn @click.stop="getAuthCode('OK')" color="#ee8208" dark block class="my-2">
                            <v-icon left size="25">{{ icon_ok }}</v-icon>
                            Одноклассники
                        </v-btn>
                    </v-card-text>

                    <v-card-subtitle>
                        <div>
                            Для участии в закупках необходимо авторизоваться
                        </div>
                        <div>
                            <a @click="openVkWeb" href="#">Сменить аккаунт в Вконтакте</a>
                        </div>
                    </v-card-subtitle>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapState} from 'vuex'
import {mdiVk, mdiOdnoklassniki} from '@mdi/js';

export default {
    name: "Auth",
    data() {
        return {
            icon_ok: mdiOdnoklassniki,
            icon_vk: mdiVk,
            vk_url: ''
        }
    },
    methods: {
        getAuthCode(type) {
            this.$storage.remove(`${location.host}-token`); // Необходимо, иначе старые токены не дают попасть на сайт.
            this.$store.state.auth.loading = true;
            let redirect_uri = location.origin.replace(/(http[s]?:\/\/)([\w-]*\.)(.*)/g, '$1$3')
            let subdomain = location.origin.replace(/(http[s]?:\/\/)([\w-]*)\.(.*)/g, '$2')
            switch (type) {
                case 'VK': {
                    this.$storage.set('auth-data', {
                        provider: 'vk-oauth2',
                        redirect_uri: redirect_uri,
                    })
                    // https://oauth.vk.com/authorize?client_id=7016621&redirect_uri=https://mt.sadpos.ru/users/login&response_type=code&scope=+4530181&state=/
                    // window.open(`https://oauth.vk.com/authorize?client_id=7334096&redirect_uri=${window.location.origin}/&response_type=code&scope=offline,photos,groups`, '_self');
                    // https://oauth.vk.com/oauth/authorize?client_id=8059812&redirect_uri=https%3A%2F%2Fposred.pro&response_type=code&scope=327684&v=5.131&state=test&display=page&display=page&success=1
                    window.open(`https://oauth.vk.com/authorize?client_id=8059867&redirect_uri=${redirect_uri}&response_type=code&scope=327684&state=${subdomain}&display=page`, '_self');
                    break
                }
                case 'OK': {
                    this.$storage.set('auth-data', {
                        provider: 'odnoklassniki-oauth2',
                        redirect_uri: redirect_uri
                    })
                    window.open(`https://connect.ok.ru/oauth/authorize?client_id=512000799994&scope=VALUABLE_ACCESS;PHOTO_CONTENT;GROUP_CONTENT&response_type=code&redirect_uri=${redirect_uri}&state=${subdomain}`, '_self');
                    break
                }
            }
        },
        openVkWeb() {
            const vkTab = window.open('about:blank', "_blank")
            vkTab.location.href = 'https://vk.com/'
        }
    },
    computed: {
        ...mapState('auth', [
            'loading'
        ]),
        ...mapState('auth', [
            'isAuth'
        ])
    },
    mounted() {
        let responseCode = this.$route.query.code;
        let subdomain = this.$route.query.state;

        if (!responseCode) {
            this.$storage.set('redirect_auth', window.location.pathname + window.location.search, {ttl: 5 * 60 * 1000});

            // let redirect_uri = location.origin.replace(/(http[s]?:\/\/)([\w-]*\.)(.*)/g, '$1$3')
            // let subdomain = location.origin.replace(/(http[s]?:\/\/)([\w-]*)\.(.*)/g, '$2')
            this.$storage.set('auth-data', {
                provider: 'vk-oauth2',
                redirect_uri: location.origin,
            })
            this.vk_url = `https://oauth.vk.com/authorize?client_id=8059867&redirect_uri=${location.origin}&response_type=code&scope=327684&display=page`

        }

        if (!this.isAuth) {
            document.title = 'Авторизация';
            if (subdomain && responseCode) {
                const url = location.protocol + '//' + subdomain + '.' + location.host + location.pathname + '?code=' + responseCode;
                window.open(url, '_self')
                return
            }
            if (responseCode) {
                this.$router.replace({
                    name: this.$router.history.current.name,
                    query: {}
                })
                let data = {
                    ...this.$storage.get('auth-data'),
                    code: responseCode
                }

                if (!['odnoklassniki-oauth2', 'vk-oauth2'].includes(data.provider)) {
                    this.$store.commit('auth/logout')
                    location.reload()
                    return
                }

                this.$store.dispatch('auth/socialAuth', data);
            }
        }
    },
    created() {
        // if (location.host.includes('192.168.0.113')) {
        //     this.$storage.set(`${location.host}-token`, 'ce966430008abb726e95ee6887951d4bcccaf208', {ttl: 1000 * 60 * 60 * 24 * 7});
        // }

        let token = this.$storage.get(`${location.host}-token`);

        if (token) {
            this.$store.commit('auth/setIsAuth')
        }
    },
}
</script>

<style scoped>
.container-auth {
    background-color: white;
    border-radius: 5px;
    border: 1px solid #e1e1e1;
}

.description {
    font-size: 12px;
    margin-top: 10px;
}

.title {
    font-size: 20px;
    text-align: center;
    margin-bottom: 40px;
}

.auth-spinner {
    width: 18px;
    height: 18px;
    font-size: 10px;
}
</style>